import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProductSpecifications } from 'app/entities/product-specification/product-specification.reducer';
import { getEntities as getSuppliers } from 'app/entities/supplier/supplier.reducer';
import { ContractType } from 'app/shared/model/enumerations/contract-type.model';
import { Variant } from 'app/shared/model/enumerations/variant.model';
import { CommercialBusiness } from 'app/shared/model/enumerations/commercial-business.model';
import { createEntity, getEntity, reset, updateEntity } from './product-offering.reducer';

export const ProductOfferingUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const productSpecifications = useAppSelector(state => state.productSpecification.entities);
  const suppliers = useAppSelector(state => state.supplier.entities);
  const productOfferingEntity = useAppSelector(state => state.productOffering.entity);
  const loading = useAppSelector(state => state.productOffering.loading);
  const updating = useAppSelector(state => state.productOffering.updating);
  const updateSuccess = useAppSelector(state => state.productOffering.updateSuccess);
  const contractTypeValues = Object.keys(ContractType);
  const variantValues = Object.keys(Variant);
  const commercialBusinessValues = Object.keys(CommercialBusiness);

  const handleClose = () => {
    navigate('/product-offering');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProductSpecifications({}));
    dispatch(getSuppliers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...productOfferingEntity,
      ...values,
      productSpecification: productSpecifications.find(
        it => it.id.toString() === values.productSpecification?.toString(),
      ),
      supplier: suppliers.find(it => it.id.toString() === values.supplier?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          contractType: 'FIXED',
          variant: 'STANDARD',
          commercialBusiness: 'ONE_YEAR',
          ...productOfferingEntity,
          productSpecification: productOfferingEntity?.productSpecification?.id,
          supplier: productOfferingEntity?.supplier?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.productOffering.home.createOrEditLabel"
            data-cy="ProductOfferingCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.productOffering.home.createOrEditLabel">
              Create or edit a ProductOffering
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="product-offering-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.productOffering.contractType')}
                id="product-offering-contractType"
                name="contractType"
                data-cy="contractType"
                type="select"
              >
                {contractTypeValues.map(contractType => (
                  <option value={contractType} key={contractType}>
                    {translate(`crawlerBackendApp.ContractType.${contractType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.productOffering.variant')}
                id="product-offering-variant"
                name="variant"
                data-cy="variant"
                type="select"
              >
                {variantValues.map(variant => (
                  <option value={variant} key={variant}>
                    {translate(`crawlerBackendApp.Variant.${variant}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.productOffering.commercialBusiness')}
                id="product-offering-commercialBusiness"
                name="commercialBusiness"
                data-cy="commercialBusiness"
                type="select"
              >
                {commercialBusinessValues.map(commercialBusiness => (
                  <option value={commercialBusiness} key={commercialBusiness}>
                    {translate(`crawlerBackendApp.CommercialBusiness.${commercialBusiness}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="product-offering-productSpecification"
                name="productSpecification"
                data-cy="productSpecification"
                label={translate('crawlerBackendApp.productOffering.productSpecification')}
                type="select"
              >
                <option value="" key="0" />
                {productSpecifications
                  ? productSpecifications.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="product-offering-supplier"
                name="supplier"
                data-cy="supplier"
                label={translate('crawlerBackendApp.productOffering.supplier')}
                type="select"
              >
                <option value="" key="0" />
                {suppliers
                  ? suppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/product-offering"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProductOfferingUpdate;
